module.exports = __webpack_public_path__ + "img/scuba-promotion.f7f01d2d.png";